import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n"; // Import i18n configuration
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { settings } from "./config/settings";

// Clear any invalid auth data on app start
const token = localStorage.getItem(settings.STORAGE_KEYS.AUTH_TOKEN);
const userData = localStorage.getItem(settings.STORAGE_KEYS.USER_DATA);

if (token && !userData) {
  localStorage.removeItem(settings.STORAGE_KEYS.AUTH_TOKEN);
  localStorage.removeItem(settings.STORAGE_KEYS.USER_PERMISSIONS);
}

if (userData && !token) {
  localStorage.removeItem(settings.STORAGE_KEYS.USER_DATA);
  localStorage.removeItem(settings.STORAGE_KEYS.USER_PERMISSIONS);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
